import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { personaService } from '../services/personaService';

export function useExternosSinRut(enabled = true) {
  return useQuery({ queryKey: ['externos-sin-rut'], queryFn: personaService.externos, enabled });
}

/**
 * Cuántos coguías externos esperan acceso, para el aviso de la barra lateral.
 *
 * Endpoint aparte y no `useExternosSinRut`: esto se pide en cada página y la lista
 * completa resuelve un correo por correo para decir con quién se engancharía cada uno.
 */
export function useExternosPendientes(enabled = true) {
  return useQuery({
    queryKey: ['externos-pendientes'],
    queryFn: personaService.externosPendientes,
    enabled,
    staleTime: 5 * 60 * 1000,
  });
}

/** Darle acceso al coguía de un correo: se registra una vez y toma todos sus temas. */
export function useDarAccesoPorCorreo() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (email: string) => personaService.darAcceso(email),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['externos-sin-rut'] });
      qc.invalidateQueries({ queryKey: ['externos-pendientes'] });
      qc.invalidateQueries({ queryKey: ['temas'] });
      qc.invalidateQueries({ queryKey: ['instancias'] });
    },
  });
}

export function useFusionarPersona() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ id, destinoId, commit }: { id: number; destinoId: number; commit?: boolean }) =>
      personaService.fusionar(id, destinoId, commit),
    onSuccess: (data) => {
      // Una previsualización no cambió nada; invalidar ahí solo haría trabajo de más.
      if (!data.publicado) return;
      qc.invalidateQueries({ queryKey: ['externos-sin-rut'] });
      qc.invalidateQueries({ queryKey: ['temas'] });
      qc.invalidateQueries({ queryKey: ['instancias'] });
    },
  });
}
